import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import {UploadIcon} from '@/components/assets/icons/svgs';
import { FileTypes } from '@/shared/utils/enum';
import CustomButton from '../button/customButton';
import { useTranslation } from 'react-i18next';
const DragDropImagePicker = ({ onImageSelected, acceptedFile, isRequired=true }: any) => {
    const { t } = useTranslation();
  const onDrop = useCallback((acceptedFiles: any) => {
    // Do something with the dropped files (e.g., preview or upload)
    if (acceptedFiles && acceptedFiles.length > 0) {
      const file = acceptedFiles;
      onImageSelected(file);
    }
  }, [onImageSelected]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: 
      acceptedFile ===  FileTypes.image ?
      {'image/*': ['.jpeg', '.png']}:
      {'application/pdf': ['.pdf',]}
    , // Specify accepted file types
  });

  return (
    <div {...getRootProps()} className='border border-[#9aa3b5] rounded-lg border-dashed p-4 cursor-pointer'>
      <input {...getInputProps()} multiple />
      {isDragActive ? (
        <div className='flex flex-col items-center gap-2'>
        <UploadIcon />
        <p className='text-[#424654]'>{t('o')}</p>
        <p className='text-[#424654] mb-4 text-center text-sm'>{`Suelta el ${acceptedFile} aquí...`}</p>
        <CustomButton className='btn-primary-lg' label='Explorar'>
        </CustomButton>
      </div>
      ) : (
        <div className='flex flex-col items-center gap-2'>
          <UploadIcon />
          <p className='text-[#424654]'>{t('o')}</p>
          <p className='text-[#424654] mb-4 text-center text-sm'>{`${t('upload_or_drag_image')} ${acceptedFile} ${t('optional')}`}{isRequired ? <span className='text-primary text-center ml-1'>*</span> : null}</p>
          {/* <CustomButton className='btn-primary-lg'  label='Browse' /> */}
        </div>
      )}
    </div>
  );
};

const dropzoneStyles: any = {
  border: '2px dashed #ccc',
  borderRadius: '16px',
  padding: '3rem',
  textAlign: 'center',
  cursor: 'pointer',
};

export default DragDropImagePicker;